module.exports = __webpack_public_path__ + "static/media/BAL-USDT.4a8608e0.svg";